import {
  Gender,
  MaritalStatus,
  UserSummaryType,
} from '../../../../../api/types/user/user-summary.type';
import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import dateUtils from '../../../../../utils/date-format';
import phoneNumberUtils from '../../../../../utils/international-to-israeli';

const isEmpty = (str?: string) => !(str && str.trim() !== '');

export const updateUserDetailsOperation = async (
  userId: number,
  firstName: string,
  lastName: string,
  nationalId: string,
  phoneNumber: string,
  additionalPhoneNumber: string | null,
  mail: string,
  dateOfBirth: Date | null,
  city: string | null,
  street: string | null,
  houseNumber: string | null,
  flatNumber: string | null,
  postcode: string | null,

  gender: Gender | null,
  immigrateCountry: string | null,
  immigrateDate: Date | null,
  maritalStatus: MaritalStatus | null,
): Promise<UserSummaryType | null> => {
  try {
    // Only validate required fields (address fields are optional)
    if (
      isEmpty(firstName) ||
      isEmpty(lastName) ||
      isEmpty(nationalId) ||
      isEmpty(phoneNumber) ||
      isEmpty(mail) ||
      gender === null ||
      !dateOfBirth
    ) {
      toast.warn('יש להשלים את כל הפרטים');
      return null;
    }

    const response = await appApi.updateUserDetails(
      userId,
      firstName,
      lastName,
      nationalId,
      /*`+972${phoneNumber.replace(/-/g, '').substring(1)}`,*/
      phoneNumberUtils.israeliPhoneToInternation(phoneNumber),
      additionalPhoneNumber,
      mail,
      dateUtils.formattedDateWithNoTime(dateOfBirth),
      city,
      street,
      houseNumber,
      flatNumber,
      postcode,
      gender,
      immigrateCountry,
      immigrateDate,
      maritalStatus,
    );
    window.location.reload();

    toast.success('הפרטים עודכנו בהצלחה');
    return response.data.body;
  } catch (e) {
    console.error(
      `updateUserDetailsOperation is failed with the userId: ${userId}, firstName: ${firstName}, lastName: ${lastName}, nationalId: ${nationalId}, phoneNumber: ${phoneNumber}, mail: ${mail}, dateOfBirth: ${dateOfBirth}, city: ${city}, street: ${street}, houseNumber: ${houseNumber}, flatNumber: ${flatNumber}, postcode: ${postcode}, gender: ${gender}, immigrateCountry: ${immigrateCountry}, immigrateDate: ${immigrateDate}, maritalStatus: ${maritalStatus} with the error: ${e}`,
    );

    toast.error('משהו קרה, נסה שוב בעוד מספר רגעים...');
    return null;
  }
};
